import styled from "styled-components"

export const StyledSearchIngredients = styled.div`
  --input-height: 35px;
  height: calc(100% - var(--header-height));
`
